import { Link } from 'react-router-dom'
import { paths } from 'src/routes/paths'
import { useLocalization } from 'src/shared/hooks/useLocalization'

export const TermsSection = () => {
  const { t } = useLocalization()
  const linkClassName =
    'text-[length:inherit] font-normal text-foreground/55 underline decoration-foreground/25 underline-offset-2 transition-colors hover:text-foreground hover:decoration-foreground/50'

  return (
    <p className="text-center text-xs font-normal leading-relaxed text-muted-foreground">
      {t(
        'By continuing you agree to Klayder’s ',
        'Genom att fortsätta godkänner du Klayders '
      )}
      <Link
        to={paths.termsOfService}
        target="_blank"
        rel="noopener noreferrer"
        className={linkClassName}
      >
        {t('terms of service', 'användarvillkor')}
      </Link>
      {t(' and ', ' och ')}
      <Link
        to={paths.privacyPolicy}
        target="_blank"
        rel="noopener noreferrer"
        className={linkClassName}
      >
        {t('privacy policy', 'integritetspolicy')}
      </Link>
      .
    </p>
  )
}
